export default "__VITE_ASSET__CYIS9OeI__"